/// <reference path="../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />

import { TaskListResultStatus, TaskList } from '../transcriptionManager/TaskList';
import { ITranscription } from '../interfaces/ITranscriptionManager';
import { IAuthenticationProvider } from '../interfaces/IAuthenticationProvider';
import { IOneDriveUploadTaskResult, OneDriveUploadTask, OneDriveUploadTaskResultStatus } from '../oneDrive/OneDriveUploadTask';
import { IStoredTranscription } from '../interfaces/IStoredTranscription';
import { LoadTranscriptionSourceFileToStoreAndNavigateToTranscribingPage } from '../../frontend/actions/LoadingActions';
import { IForegroundTask } from '../interfaces/IForegroundTask';
import { LogEvents } from '../../utils/LogEvents';
import { CancelableWait, ErrorStringFromException, isNullOrUndefined, PromiseWithRetry, waitIfSystemInSleepState } from '../../utils/utils';
import { TranscriptionMonthlyQuota } from '../transcriptionManager/TranscriptionMonthlyQuota';
import { CreateTranscriptionSourceFileProvider } from '../factory/TranscriptionSourceFileFactory';
import { ITranscriptionSourceFileProvider } from '../interfaces/ITranscriptionSourceFileProvider';
import { FileUploadKeys } from '../telemetry/FileUploadKeys';
import { DurationMeasureType } from '../interfaces/ILogEvent';
import { LogError, LogErrorAndThrow, ShouldLogErrorAsWarning } from '../../utils/ErrorTelemetry';
import { ILogData, LogEventNames } from '../interfaces/ITelemetryLogger';
import { LogServiceEvent } from '../TelemetryLogger/LogServiceEvent';
import { FileUploadForegroundTaskError, FileUploadForegroundTaskErrors } from '../common/fileUpload/FileUploadForegroundTaskErrors';
import { FrontDoorFileUpload, ConversationId, FrontDoorUploadResult } from '../frontDoor/FrontDoorFileUpload';
import { FrontDoorFileUploadError } from '../frontDoor/FrontDoorFileUploadErrors';
import { BatchTranscriptionClientRequestPoller, IBatchTranscriptionClientResult, initializeBatchTranscriptionClient, uninitializeBatchTranscriptionClient, BatchTranscriptionClientError, BatchTranscriptionClientErrorCode } from '@1js/al-voice-client';
import { EnsureAugloopRuntimeManager, GetAugloopEventEmitter } from '../augloop/Augloop';
import { IAugLoopRuntimeManager } from '@augloop/office-online';
import { RetryServiceCallUntilSuccessOrTimeout, RetryServiceCaller } from '../utils/Utils';
import { v4 as uuidv4 } from 'uuid';
import { AugloopEvent } from '../interfaces/IAugloopEventEmitter';
import { CheckNetworkConnection, GetNetworkConnectionMonitorInstance, InternetState, IsConnectedToNetwork, NetworkConnectionListener } from '../../frontend/NetworkConnectionMonitor';
import { TranscriptionRoutePathNames } from '../../frontend/routes';
import { GetDefaultTranscriptionLocale } from '../../utils/TranscriptionLanguages';
import { GET_BATCH_CONVERSATION_TRANSCRIPTION_TIMEOUT_MILLISECONDS, FILE_UPLOAD_POLLING_DELAY_MILLISECONDS, FileUploadEntryPoints, TranscribingEntryPoints, MAX_RETRY_ATTEMPTS_FOR_WRITE_REQUEST, MAX_RETRY_DELAY_FOR_WRITE_REQUEST_IN_MSEC } from '../../AppConstants';
import { GetDelayTimeInMilliSecondForBatchTranscriptionTask } from '../common/fileUpload/FileUploadForegroundTaskUtil';
import { TranscriptionManagerFactory } from '../factory/TranscriptionManagerFactory'
import { IAnnotationObserver } from '@1js/al-voice-client';
import { GetSupportedTranscriptionStorageType, HostAppSettingName, HostAppSettings } from '../office-js/HostAppSettings';
import { IOneDriveItemInfo } from '../interfaces/IOneDriveItem';
import * as parsing from '../documentStorage/DocumentStorageTranscriptionManagerParsing';
import { TranscriptionTelemetryErrorCodes } from '../../utils/TranscriptionTelemetryErrorCodes';
import { AugloopKeys } from '../augloop/telemetry/AugloopKeys';
import { LogSingleEvent } from '../TelemetryLogger/LogEvent';
import { TranscriptionData } from '../utils/TranscriptionData';
import { SetLoadingPercentDone, SetLoadingStatus, RescalePercent, GetFileContentTypeFileUpload, CheckIfFileValidToUpload, GetTranscriptionFromBatchTranscriptionResult, PublicErrorFromFrontDoorUploadError } from '../common/fileUpload/fileUploadTask'
import { LoadingStatus } from '../../frontend/common/enums/loadingEnums';
import { IAddTranscriptionIndicatorToHost } from '../interfaces/IAddTranscriptionIndicatorToHost';
import { CreateAddTranscriptionIndicatorProvider } from '../factory/AddTranscriptionIndicatorToHostFactory';
import { ITranscriptionErrorEvent } from '../interfaces/ITranscriptionErrorEvent';
import { FailureContinuation } from '../../frontend/common/enums/failureEnums';
import { LOAD_TRANSCRIPTION_STRINGS_FAILURE_MESSAGE } from '../../frontend/LoadTranscriptionStrings';
import * as AudioBackup from '../interfaces/IAudioBackup';
import { SetFailureStateAndRouteToFailure } from '../../frontend/actions/FailureActions';
import { TranscriptionHistoryDump } from '../utils/TranscriptionHistoryDump';
import { BatchWorkflowStage, TranscriberType } from '@augloop-types/voice';
import { ProvisionAuthenticationToken } from '../office-js/auth/IdentityUtil';
import { getAuthEnvironment } from '../office-js/HostAppSettings';
import { AuthEnvironment } from '../interfaces/IAuthenticationProvider';

type BatchTranscriptionUploadTaskListTypes = void | FrontDoorUploadResult | ITranscription | IOneDriveItemInfo | string;
type StoredTranscriptionAndSourceFileProvider = { storedTranscription: IStoredTranscription, sourceFileProvider: ITranscriptionSourceFileProvider };

enum FileUploadState {
  INITIALIZED = 'INITIALIZED',
  CHECK_FILE_VALIDITY = 'CHECK_FILE_VALIDITY',
  FILE_UPLOAD_TO_ONEDRIVE_INITIATED = 'FILE_UPLOAD_TO_ONEDRIVE_INITIATED',
  FILE_UPLOAD_TO_ONEDRIVE_SUCCESS = 'FILE_UPLOAD_TO_ONEDRIVE_SUCCESS',
  GET_ONE_DRIVE_ITEM_BY_ID_REQUEST = 'GET_ONE_DRIVE_ITEM_BY_ID_REQUEST',
  ANALYSE_AUDIO_AT_FRONTDOOR_INITIATED = 'ANALYSE_AUDIO_AT_FRONTDOOR_INITIATED',
  ANALYSE_AUDIO_AT_FRONTDOOR_SUCCESS = 'ANALYSE_AUDIO_AT_FRONTDOOR_SUCCESS',
  FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED = 'FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED',
  FETCH_BATCH_TRANSCRIPTION_RESULT_SUCCESS = 'FETCH_BATCH_TRANSCRIPTION_RESULT_SUCCESS',
  WRITE_TRANSCRIPTION_TO_STORAGE = 'WRITE_TRANSCRIPTION_TO_STORAGE',
  ADD_MINUTES_TO_HOST = 'ADD_MINUTES_TO_HOST',
  ADD_MINUTES_TO_HOST_SUCCESS = 'ADD_MINUTES_TO_HOST_SUCCESS',
  FINISHED = 'FINISHED',
  PAUSED = 'PAUSED',
  RESUMED = 'RESUMED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  FAILED_WITH_WARNING = "FAILED_WITH_WARNING"
}

// This class contains the logic we execute when the Loading page is shown to the user in the File Upload scenario.
export class FileUploadForegroundTask implements IForegroundTask, NetworkConnectionListener {
  private file: File;
  private authProvider: IAuthenticationProvider;
  private history: any;
  private taskList: TaskList<any> | null = null;
  private batchTranscriptionUploadTaskList: TaskList<BatchTranscriptionUploadTaskListTypes> | null = null;
  private oneDriveUploadTask: OneDriveUploadTask | null = null;
  private oneDriveUploadResult: IOneDriveUploadTaskResult | null = null;
  private serviceFileDurationSeconds: number | null = null; // File duration provided by the service (FrontDoor), used for monthly quota.
  private frontDoorUpload: FrontDoorFileUpload | null = null;
  private transcriptionUploadProgressInterval: number | null = null;
  private oneDriveUploadPromise: Promise<IOneDriveUploadTaskResult> | null = null;
  private batchTranscriptionClientRequestPoller: BatchTranscriptionClientRequestPoller | null = null;
  private alRuntimeManager: IAugLoopRuntimeManager | null = null;
  private removeBatchTranscriptionEventHandlers: null | (() => void) = null;
  private annotationObserver: IAnnotationObserver | undefined;
  private fileUploadTaskProgressPercentageTimer: number | null = null;
  private fileUploadEntryPoint: FileUploadEntryPoints = FileUploadEntryPoints.DEFAULT;
  private readonly transcriptionMonthlyQuotaWaitTime: number = 60000;
  private audioBackup: AudioBackup.IAudioBackup | null = null;
  private isCancelledTask: boolean = false;
  private makeBatchTranscriptionRetryReqObj: any;
  private batchTranscriptionInitRetryObj: any;
  private fileUploadState: FileUploadState;
  private fileUploadStateBeforePause: FileUploadState;
  private WakeUpCallObserver: any;
  private fileUploadResumeCallbackList = new Set<Function>();
  private fileUploadHistory = new TranscriptionHistoryDump();

  private readonly fileUploadWithUrlPercentagesRanges = {
    initialPercentage: [0, 0.01],
    fileUploadToOneDrive: [0.02, 0.42],
    getOneDriveItemByIdRequest: [0.43],
    analyzeAudioAtFrontDoor: [0.44, 0.45],
    batchTranscriptionClientInitialized: [0.46],
    getBatchTranscriptionResult: [0.47, 0.95],
    saveTranscriptionToDocStorage: [0.96, 0.96],
    updateUploadMinutesToHost: [0.97, 0.99],
    finishUpload: [1]
  };

  constructor(file: File, authProvider: IAuthenticationProvider, history: any, fileUploadEntryPoint: FileUploadEntryPoints = FileUploadEntryPoints.DEFAULT, audioBackup: AudioBackup.IAudioBackup | null = null) {
    this.file = file;
    this.authProvider = authProvider;
    this.history = history;
    this.fileUploadEntryPoint = fileUploadEntryPoint;
    this.audioBackup = audioBackup;
    LogEvents.FileUpload.Start();
    LogEvents.FileUpload.BeginDurationMeasure(DurationMeasureType.Normal, FileUploadKeys.TotalUploadDuration);
    this.annotationObserver = {
      onAnnotationResult: (op) => {
        if (this.batchTranscriptionClientRequestPoller) {
          this.batchTranscriptionClientRequestPoller.onAnnotationResult(op);
        }
      },
    };
    this.fileUploadState = FileUploadState.INITIALIZED;
    this.fileUploadStateBeforePause = FileUploadState.INITIALIZED;

    GetNetworkConnectionMonitorInstance().addListener(this);
  }

  onInternetConnectionStatusChanged(state: InternetState): void {
    this.fileUploadHistory.AddEventToTranscriptionHistory("onInternetConnectionStatusChanged: " + state);
    switch (state) {
      case InternetState.INTERNET_CONNECTED:
        this.updateFileUploadState(FileUploadState.RESUMED);
        break;
      case InternetState.INTERNET_DISCONNECTED:
        this.updateFileUploadState(FileUploadState.PAUSED);
        break;
    }
  }

  private CleanUpTaskState() {
    this.clearFileUploadTaskProgressPercentageTimer();
    this.taskList = null;
    this.batchTranscriptionUploadTaskList = null;
    this.oneDriveUploadTask = null;
    this.frontDoorUpload = null;
    this.transcriptionUploadProgressInterval = null;
    this.oneDriveUploadResult = null;
    GetNetworkConnectionMonitorInstance().removeListener(this);
  }

  private onAugLoopSessionDisconnectEvent = () => {
    this.fileUploadHistory.AddEventToTranscriptionHistory("onAugLoopSessionDisconnectEvent ");
    if (this.fileUploadState == FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED) {
      this.updateFileUploadState(FileUploadState.PAUSED);
    }
  }

  private updateFileUploadState(fileUploadnewState: FileUploadState) {

    // check for same state update.
    if (fileUploadnewState == this.fileUploadState) {
      return;
    }

    //RESUME state should be just after PUASED state.
    else if (fileUploadnewState == FileUploadState.RESUMED && this.fileUploadState != FileUploadState.PAUSED) {
      return;
    }

    //clean up handling for previous state before entering new state.
    this.exitFileUploadState(this.fileUploadState);

    //add new state to File upload History.
    this.fileUploadHistory.AddEventToTranscriptionHistory(fileUploadnewState);

    //update new state.
    if (fileUploadnewState == FileUploadState.PAUSED) {
      this.fileUploadStateBeforePause = this.fileUploadState;
    }
    this.fileUploadState = fileUploadnewState;

    switch (fileUploadnewState) {
      case FileUploadState.CHECK_FILE_VALIDITY:
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.initialPercentage[1]);
        break;
      case FileUploadState.FILE_UPLOAD_TO_ONEDRIVE_INITIATED:

        //Show Upload File to onedrive Status.
        SetLoadingStatus(LoadingStatus.UploadingFile);

        // Setting up upload percentage to 2% on file upload start.
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.fileUploadToOneDrive[0]);
        break;
      case FileUploadState.FILE_UPLOAD_TO_ONEDRIVE_SUCCESS:
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.fileUploadToOneDrive[1]);
        break;
      case FileUploadState.GET_ONE_DRIVE_ITEM_BY_ID_REQUEST:
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.getOneDriveItemByIdRequest[0]);
        break;
      case FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_INITIATED:
        break;
      case FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_SUCCESS:
        SetLoadingStatus(LoadingStatus.TranscribingAudio);

        // Setting pecentage to 46% on analyze audio on frontdoor completion.
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.analyzeAudioAtFrontDoor[1]);
        break;
      case FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED:
        GetAugloopEventEmitter().on(AugloopEvent.SessionDisconnect, this.onAugLoopSessionDisconnectEvent);

        //Set Loading Status to transcribing audio.
        SetLoadingStatus(LoadingStatus.TranscribingAudio);

        // Setting up upload percentage to 47% on get batch transcription start.
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[0]);

        if (this.makeBatchTranscriptionRetryReqObj != null) {
          this.makeBatchTranscriptionRetryReqObj.continueToNextAttempt();
        }
        break;
      case FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_SUCCESS:
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[1]);
        break;
      case FileUploadState.WRITE_TRANSCRIPTION_TO_STORAGE:
        SetLoadingStatus(LoadingStatus.TranscribingAudio);
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.saveTranscriptionToDocStorage[0]);
        break;
      case FileUploadState.ADD_MINUTES_TO_HOST:
        SetLoadingStatus(LoadingStatus.TranscribingAudio);
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.updateUploadMinutesToHost[0]);
        break;
      case FileUploadState.ADD_MINUTES_TO_HOST_SUCCESS:
        SetLoadingStatus(LoadingStatus.TranscribingAudio);
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.updateUploadMinutesToHost[1]);
        break;
      case FileUploadState.PAUSED:
        SetLoadingStatus(LoadingStatus.WaitForConnection);

        // start a wakeupCallObserver, window interval event stops coming in when system is in Sleep mode.
        this.WakeUpCallObserver = setInterval(async () => {
          if (IsConnectedToNetwork() && await GetNetworkConnectionMonitorInstance().isPingConnected()) {
            this.updateFileUploadState(FileUploadState.RESUMED);
          }
        }, 10000);
        break;
      case FileUploadState.RESUMED:
        this.updateFileUploadState(this.fileUploadStateBeforePause);
        break;
      case FileUploadState.FAILED:
        this.fileUploadHistory.LogTranscriptionHistory(LogEventNames.FileUpload, 'File Upload History Dump');
        break;
      case FileUploadState.FAILED_WITH_WARNING:
        break;
      case FileUploadState.CANCELED:
        this.fileUploadHistory.LogTranscriptionHistory(LogEventNames.FileUpload, 'User Canceled, File Upload History Dump');
        break;
      case FileUploadState.FINISHED:
        this.TrySetLoadingPercentDone(this.fileUploadWithUrlPercentagesRanges.finishUpload[0]);
        break;
    }
  }

  /* Called for current File Upload State, before applying new fileUploadState.
  All clean up code for any State can come here.*/
  private exitFileUploadState(state: FileUploadState) {
    switch (state) {
      case FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED:
        GetAugloopEventEmitter().removeListener(AugloopEvent.SessionDisconnect, this.onAugLoopSessionDisconnectEvent);
        break;
      case FileUploadState.PAUSED:
        if (!isNullOrUndefined(this.WakeUpCallObserver)) {
          clearInterval(this.WakeUpCallObserver);
        }
        this.NotifyFileUploadResumeEvent();
        break;
    }
  }

  private StartFileUploadTaskProgressPercentageTimer(startPercentage: number, endPercentage: number, delay: number) {
    let currentPercentage = startPercentage;

    let timer = window.setInterval(() => {
      if (currentPercentage + 0.01 < endPercentage && this.fileUploadState != FileUploadState.PAUSED) {
        currentPercentage = currentPercentage + 0.01; // 1 % increment with each time delay interval.
        this.TrySetLoadingPercentDone(currentPercentage);
      }
    }, delay);
    this.fileUploadTaskProgressPercentageTimer = timer;
  }

  private clearFileUploadTaskProgressPercentageTimer() {
    if (this.fileUploadTaskProgressPercentageTimer != null) {
      window.clearInterval(this.fileUploadTaskProgressPercentageTimer);
      this.fileUploadTaskProgressPercentageTimer = null;
    }
  }

  public HandleError(errorCode: TranscriptionTelemetryErrorCodes): void {
    switch (errorCode) {
      case TranscriptionTelemetryErrorCodes.LostInternetConnectionReason:
        LogError(LogEventNames.Warning, "File Upload failure. " + TranscriptionTelemetryErrorCodes.ConnectionIssueFailureReason);

        // don't clean up audio backup as it should get recovered once Internet is connected back.
        this.updateFileUploadState(FileUploadState.CANCELED);
        this.CancelAndClearBackup(false /*shouldClearBackup*/);

        let transcriptionErrorEvent: ITranscriptionErrorEvent | undefined = { errorEventMessage: LOAD_TRANSCRIPTION_STRINGS_FAILURE_MESSAGE, errorEventName: LOAD_TRANSCRIPTION_STRINGS_FAILURE_MESSAGE };

        // TranscriptionStrings can be null if the user goes offline before TranscriptionStrings is loaded during boot.
        if (TranscriptionStrings != null) {
          transcriptionErrorEvent = { errorEventMessage: TranscriptionStrings.LostInternetConnectionReason, errorEventName: TranscriptionTelemetryErrorCodes.LostInternetConnectionReason };
        }

        // Navigate to the failure page.
        SetFailureStateAndRouteToFailure(
          LogEventNames.Warning,
          transcriptionErrorEvent!,
          FailureContinuation.None,
          this.history);
    }
  }

  private clearDBOnFileUploadSuccessOrCancel = async () => {
    if (this.audioBackup != null) {
      await this.audioBackup.ClearBackup();
    }
  }

  public async Execute(): Promise<void> {
    try {

      this.isCancelledTask = false;
      // Default to indeterminate until we figure out if we can get a preliminary audio length.
      SetLoadingPercentDone(null);

      this.taskList = this.GetFileUploadWithUrlTaskList();

      const result = await this.taskList.ExecuteTaskListSequentially();

      this.CleanUpTaskState();

      // If the upload was canceled, we are done.
      if (result.status == TaskListResultStatus.Canceled) {
        LogEvents.FileUpload.End();
        LogEvents.ServiceLiveSpeechToText.AddResponse({ isSuccessful: true, message: 'User canceled', isFinalResponse: true });
        return;
      }

      // Only navigate to transcribing page if we aren't already on the failure page
      // Being on the failure page signifies an incomplete transcript/other error that we already logged by navigating to the failure page
      // Swallowing that error can give the user an impression that the transcription experience is inconsistent - especially if they never saw the error in the first place
      if (this.history.location.pathname != TranscriptionRoutePathNames.Failure) {
        const sourceFile = await LoadTranscriptionSourceFileToStoreAndNavigateToTranscribingPage(result.result, this.history, true /* isNewTranscript */, TranscribingEntryPoints.FILE_UPLOAD);

        //Show Transcription indicator on Host App
        if (HostAppSettings.IsSettingTrue(HostAppSettingName.AddTranscriptionIndicatorToHostEnabled)) {
          const addTranscriptionIndicatorToHostProvider: IAddTranscriptionIndicatorToHost = CreateAddTranscriptionIndicatorProvider();
          addTranscriptionIndicatorToHostProvider.AddTranscriptionIndicator(sourceFile!).catch((e) => {
            LogError(LogEventNames.StoredTranscriptionIndicator, "Error adding Transcription Indicator to Host " + ErrorStringFromException(e));
          });
        }
      }

      // Show 100% progress indicator
      this.updateFileUploadState(FileUploadState.FINISHED);

      if (this.fileUploadEntryPoint == FileUploadEntryPoints.RECOVERING) {
        await this.clearDBOnFileUploadSuccessOrCancel();
      }

      LogEvents.FileUpload.EndDurationMeasure(FileUploadKeys.FileExecuteComplete);
    } catch (e: any) {

      // log error to history dump.
      const errorStr = ErrorStringFromException(e);

      await this.CancelAndClearBackup(false /*shouldClearBackup*/);

      const shouldLogErrorAsWarning = !IsConnectedToNetwork() || ShouldLogErrorAsWarning(e);

      if (shouldLogErrorAsWarning) {
        this.fileUploadHistory.AddEventToTranscriptionHistory("Failure with warning Reason : " + errorStr);
        this.updateFileUploadState(FileUploadState.FAILED_WITH_WARNING);
        LogEvents.ServiceLiveSpeechToText.AddResponse({ isSuccessful: true, message: 'cancelled because of a warning: ' + errorStr, isFinalResponse: true });
        LogEvents.FileUpload.End();
      } else {
        const failureReason = "Error uploading file, is cancelled Task (" + this.isCancelledTask + ")" + errorStr;

        this.fileUploadHistory.AddEventToTranscriptionHistory("Failure Reason : " + errorStr);
        this.updateFileUploadState(FileUploadState.FAILED);
        LogEvents.ServiceLiveSpeechToText.AddResponse({ isSuccessful: false, message: failureReason, isFinalResponse: true });
        LogEvents.FileUpload.End([{ key: FileUploadKeys.FailureReason, value: failureReason }]);
      }

      LogErrorAndThrow(shouldLogErrorAsWarning ? LogEventNames.Warning : LogEventNames.FileUpload, e);
    }
  }

  public async Cancel(): Promise<void> {
    this.isCancelledTask = true;
    this.updateFileUploadState(FileUploadState.CANCELED);
    if (this.audioBackup != null && this.fileUploadEntryPoint == FileUploadEntryPoints.RECOVERING) {
      await this.CancelAndClearBackup(true /*shouldClearBackup*/);
    } else {
      await this.CancelAndClearBackup(false /*shouldClearBackup*/);
    }
    if (this.batchTranscriptionInitRetryObj) {
      this.batchTranscriptionInitRetryObj.cancel();
    }
    if (this.makeBatchTranscriptionRetryReqObj) {
      this.makeBatchTranscriptionRetryReqObj.cancel();
    }
  }


  private async CancelAndClearBackup(shouldClearBackup: boolean): Promise<void> {
    try {
      if (shouldClearBackup) {
        await this.clearDBOnFileUploadSuccessOrCancel();
      }

      if (this.taskList != null)
        this.taskList.Cancel();

      if (this.oneDriveUploadTask != null)
        await this.oneDriveUploadTask.Cancel();

      if (this.batchTranscriptionUploadTaskList != null)
        this.batchTranscriptionUploadTaskList.Cancel();

      if (this.frontDoorUpload != null) {
        this.frontDoorUpload.Cancel();
      }

      if (this.oneDriveUploadResult != null) {
        this.oneDriveUploadResult.status = OneDriveUploadTaskResultStatus.Canceled;
      }

      if (this.transcriptionUploadProgressInterval != null) {
        clearTimeout(this.transcriptionUploadProgressInterval);
      }

      if (this.removeBatchTranscriptionEventHandlers != null)
        this.removeBatchTranscriptionEventHandlers();

      if (this.batchTranscriptionClientRequestPoller != null)
        this.DisposeBatchTranscriptionClientRequestPoller();

      uninitializeBatchTranscriptionClient(this.alRuntimeManager! as any /* TODO: ADO:4691502 remove cast */);

      this.CleanUpTaskState();
    } catch (e) {
      this.CleanUpTaskState();
      LogEvents.ServiceLiveSpeechToText.AddResponse({ isSuccessful: false, message: `Failed when cancelling foreground task: ${ErrorStringFromException(e)}`, isFinalResponse: true });
      LogErrorAndThrow(LogEventNames.FileUpload, e);
    }
  }

  private async AddUploadMinutesToHost() {
    let audioDuration = null;

    if (this.serviceFileDurationSeconds == null)
      throw new Error("Reached AddUploadMinutesToHost without serviceFileDurationSeconds");

    audioDuration = this.serviceFileDurationSeconds;

    let didAddUploadMinutes: boolean = false;
    LogEvents.FileUpload.BeginDurationMeasure(DurationMeasureType.Normal, FileUploadKeys.AddMinutesUsedDuration);

    const addMinutePromiseWaitObj = CancelableWait(this.transcriptionMonthlyQuotaWaitTime);
    const addMinutesUsedPromise = TranscriptionMonthlyQuota.GetInstance().AddMinutesUsed(Math.floor(audioDuration / 60)).then(() => {
      didAddUploadMinutes = true;
      addMinutePromiseWaitObj.cancel();
    });

    await Promise.race([addMinutePromiseWaitObj.promise, addMinutesUsedPromise]).then(() => {
      if (!didAddUploadMinutes)
        LogError(LogEventNames.Warning, "AddMinutesUsed promise timed out");
    });

    LogEvents.FileUpload.EndDurationMeasure(FileUploadKeys.AddMinutesUsedDuration);
  }

  private LogBatchTranscriptionClientRequestPollerMessage(message: string) {
    LogEvents.FileUpload.AddData([{ key: FileUploadKeys.BatchTranscriptionClientRequestPollerMessageLog, value: message }]);
  }

  private getTranscriberType(): TranscriberType {
    const authEnv = getAuthEnvironment();

    // Use OVFD for GCC, GCCHigh, DOD, and airgap (USNAT/USSEC) environments
    if (authEnv === AuthEnvironment.GCC ||
        authEnv === AuthEnvironment.GCCHigh ||
        authEnv === AuthEnvironment.DOD ||
        authEnv === AuthEnvironment.USNAT ||
        authEnv === AuthEnvironment.USSEC) {
      return TranscriberType.Ovfd;
    }

    // Use Fast for all other environments (Prod, PPE, MSIT)
    return TranscriberType.Fast;
  }

  private async MakeBatchTranscriptionRequest(conversationId: ConversationId, speechFDUrl: string, correlationId?: string, downloadUrl?: string, sourceLanguage?: string, stage: BatchWorkflowStage = BatchWorkflowStage.GetBatchResult): Promise<IBatchTranscriptionClientResult> {
    if (this.alRuntimeManager == null)
      throw new Error("alRuntimeManager is not initialized");

    if (this.batchTranscriptionClientRequestPoller != null)
      throw new Error("batchTranscriptionClientRequestPoller already initialized. Dispose it first.");

    // Convert string to enum TranscriberType
    const currentTranscriberType = this.getTranscriberType();

    this.batchTranscriptionClientRequestPoller = new BatchTranscriptionClientRequestPoller(
      FILE_UPLOAD_POLLING_DELAY_MILLISECONDS, // pollingDelayMilliseconds
      this.alRuntimeManager! as any /* TODO: ADO:4691502 remove cast */, // alRuntimeManager
      stage, // workflowStage
      downloadUrl, // downloadUrl
      conversationId, // conversationId
      correlationId, // corelationId
      speechFDUrl, // speechFDUrl
      sourceLanguage, // sourceLanguage
      currentTranscriberType, // transcriberType
      this.LogBatchTranscriptionClientRequestPollerMessage
    );

    return this.batchTranscriptionClientRequestPoller.makeRequest();
  }

  private DisposeBatchTranscriptionClientRequestPoller() {
    if (this.batchTranscriptionClientRequestPoller == null)
      throw new Error("Attempted to dispose a null batchTranscriptionClientRequest");

    this.batchTranscriptionClientRequestPoller.dispose();
    this.batchTranscriptionClientRequestPoller = null;
  }

  private async logAugloopConnectionData(alRuntimeManager: IAugLoopRuntimeManager) {
    /** Note: We are observing timeouts after 30 sec for init batch transcription client call below, adding this
         to confirm if connection with AL is available while making this request. **/
    const augloopSession /* ISession */ = await alRuntimeManager.getSession();
    const augloopConnectionData: ILogData<AugloopKeys>[] = [{ key: AugloopKeys.IsConnectedToAL, value: augloopSession.isConnected },
    { key: AugloopKeys.HasConnectedToAL, value: augloopSession.hasConnected },
    { key: AugloopKeys.ConnectionClosedWithAL, value: augloopSession.isClosed }];
    LogSingleEvent<AugloopKeys>(LogEventNames.Augloop, augloopConnectionData);
  }

  private async InitializeBatchTranscriptionClient() {
    if (this.alRuntimeManager == null) {
      throw new Error("alRuntime manager is not initialized");
    }

    this.logAugloopConnectionData(this.alRuntimeManager);

    const logServiceEventInitialize = new LogServiceEvent(LogEventNames.ServiceBatchTranscriptionInitialize);
    logServiceEventInitialize.Start();
    this.batchTranscriptionInitRetryObj = RetryServiceCallUntilSuccessOrTimeout<void>(logServiceEventInitialize, () => initializeBatchTranscriptionClient(this.alRuntimeManager! as any /* TODO: ADO:4691502 remove cast */, this.annotationObserver, true /*enable set annotations from voice client */), false /*shouldRetryOnNull*/, RetryServiceCaller.InitalizeBatchTranscriptionClientWithSetAnnotation);
  }

  private TrySetLoadingPercentDone(percentDone: number) {
    SetLoadingPercentDone(percentDone);
  }

  // If batch transcription client has not been initialized, do it.
  private async EnsureBatchTranscriptionClientInitialized(): Promise<void> {
    if (this.batchTranscriptionInitRetryObj != null)
      return this.batchTranscriptionInitRetryObj.promise;

    const onSessionConnectAfterCloseListener = () => {
      this.InitializeBatchTranscriptionClient();
    }

    const onSessionCloseListener = () => {
      GetAugloopEventEmitter().once(AugloopEvent.SessionConnect, onSessionConnectAfterCloseListener);
    }

    // If the augloop session is closed and we reconnect, re-initialize batch transcription client.
    GetAugloopEventEmitter().on(AugloopEvent.SessionClose, onSessionCloseListener);

    this.removeBatchTranscriptionEventHandlers = () => {
      GetAugloopEventEmitter().removeListener(AugloopEvent.SessionClose, onSessionCloseListener);
      GetAugloopEventEmitter().removeListener(AugloopEvent.SessionConnect, onSessionConnectAfterCloseListener);
      this.removeBatchTranscriptionEventHandlers = null;
    }

    this.InitializeBatchTranscriptionClient();

    if (this.batchTranscriptionInitRetryObj == null)
      throw new Error("Failed creating batch transcripting client");

    return this.batchTranscriptionInitRetryObj.promise;
  }

  private ShouldRetryBatchTranscriptionError(error: BatchTranscriptionClientError) {
    return (typeof error !== "undefined" && typeof error.code !== "undefined"
      && !(error.code == BatchTranscriptionClientErrorCode.DELETED
        || error.code == BatchTranscriptionClientErrorCode.FILE_NOT_EXIST
        || error.code == BatchTranscriptionClientErrorCode.FILE_DECODE_ERROR));
  }

  private async getOneDriveItemInfo(driveId: any, itemId: any): Promise<IOneDriveItemInfo> {
    try {
      if (isNullOrUndefined(driveId) || isNullOrUndefined(itemId)) {
        throw new Error('One drive item id or drive id is null')
      }
      const oneDriveItemResponse = await this.oneDriveUploadTask?.getOneDriveItemByIdRequest(driveId, itemId);
      let audioItem = parsing.ParseItemInfoFromGraphResponse(oneDriveItemResponse);
      return audioItem;
    } catch (e) {
      throw new Error('Exception in getting one drive file info/download url : ' + ErrorStringFromException(e))
    }
  }

  private async uploadFileToOneDrive(fileUploadProgressCallback: (progress: number) => void): Promise<IOneDriveItemInfo> {
    if (this.oneDriveUploadTask == null && this.oneDriveUploadPromise == null) {
      this.oneDriveUploadTask = new OneDriveUploadTask(
        this.authProvider,
        TranscriptionStrings.FolderNameToUploadAudioFiles,
        this.file,
        this.fileUploadHistory
      );
      this.oneDriveUploadPromise = this.oneDriveUploadTask.UploadFile(fileUploadProgressCallback);
    }

    if (this.oneDriveUploadPromise == null) {
      throw new Error('oneDriveUploadPromise is null');
    }

    this.oneDriveUploadResult = await this.oneDriveUploadPromise;

    if (this.oneDriveUploadResult == null) {
      throw new Error('UploadFile returned a null uploadResult');
    }

    if (this.oneDriveUploadResult.status == OneDriveUploadTaskResultStatus.Canceled) {
      throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.OneDriveUploadCanceled);
    }

    if (this.oneDriveUploadResult.oneDriveItem == null) {
      throw new Error('UploadFile returned a null oneDriveItem');
    }

    this.updateFileUploadState(FileUploadState.FILE_UPLOAD_TO_ONEDRIVE_SUCCESS);

    const audioItem = await this.getOneDriveItemInfo(
      this.oneDriveUploadResult?.oneDriveItem?.driveId,
      this.oneDriveUploadResult?.oneDriveItem?.itemId
    );

    this.updateFileUploadState(FileUploadState.GET_ONE_DRIVE_ITEM_BY_ID_REQUEST);
    return audioItem;
  }

  private createFileUploadProgressCallback(startPercentage: number, endPercentage: number): (progress: number) => void {
    const fileUploadWindowRatio = 100 / (endPercentage - startPercentage);
    return (progress: number) => {
      this.TrySetLoadingPercentDone(startPercentage + progress / fileUploadWindowRatio);
    };
  }

  private async handleBatchTranscriptionResult(batchTranscriptionResult: any, locale: string) {
    if (this.batchTranscriptionClientRequestPoller != null) {
      this.batchTranscriptionClientRequestPoller!.dispose();
    }

    uninitializeBatchTranscriptionClient(this.alRuntimeManager! as any);

    if (this.removeBatchTranscriptionEventHandlers != null) {
      this.removeBatchTranscriptionEventHandlers();
    }

    this.clearFileUploadTaskProgressPercentageTimer();
    this.updateFileUploadState(FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_SUCCESS);

    const transcript = GetTranscriptionFromBatchTranscriptionResult(batchTranscriptionResult, locale);
    if (transcript != null && transcript.transcriptSegments.length > 0) {
      const last = transcript.transcriptSegments[transcript.transcriptSegments.length - 1];
      const time: number = last.end;
      this.serviceFileDurationSeconds = time;
      LogEvents.FileUpload.AddData([
        { key: FileUploadKeys.ServiceFileDurationSeconds, value: this.serviceFileDurationSeconds }
      ]);
    }
    return transcript;
  }

  private GetBatchTranscriptionUploadWithUrlTaskList(): TaskList<BatchTranscriptionUploadTaskListTypes> {
    const locale = GetDefaultTranscriptionLocale();
    const currentTranscriberType = this.getTranscriberType();

    const baseTaskList = [
      // Check file validity and log audio duration
      async () => {
        this.updateFileUploadState(FileUploadState.CHECK_FILE_VALIDITY);
        CheckIfFileValidToUpload(this.file, this.fileUploadEntryPoint);
      },

      // Upload file to OneDrive
      async (): Promise<IOneDriveItemInfo> => {
        this.updateFileUploadState(FileUploadState.FILE_UPLOAD_TO_ONEDRIVE_INITIATED);
        SetLoadingStatus(LoadingStatus.UploadingFile);

        const progressCallback = this.createFileUploadProgressCallback(
          this.fileUploadWithUrlPercentagesRanges.fileUploadToOneDrive[0],
          this.fileUploadWithUrlPercentagesRanges.fileUploadToOneDrive[1]
        );

        return await this.uploadFileToOneDrive(progressCallback);
      }
    ];

    if (currentTranscriberType === TranscriberType.Cts) {
      return new TaskList<BatchTranscriptionUploadTaskListTypes>([
        ...baseTaskList,

        // Initialize batch transcription client
        async (oneDriveItemInfo: IOneDriveItemInfo): Promise<IOneDriveItemInfo> => {
          this.TrySetLoadingPercentDone(
            this.fileUploadWithUrlPercentagesRanges.batchTranscriptionClientInitialized[0]
          );

          await this.EnsureProperConnectivity();
          await ProvisionAuthenticationToken(this.authProvider);
          this.alRuntimeManager = await EnsureAugloopRuntimeManager();
          await this.EnsureBatchTranscriptionClientInitialized();
          return oneDriveItemInfo;
        },

        // Analyze audio
        async (audioItemInfo: IOneDriveItemInfo): Promise<string> => {
          let batchTranscriptionResult = null;

          try {
            if (!audioItemInfo.downloadUrl) {
              throw new Error("Download URL is null");
            }

            this.updateFileUploadState(FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_INITIATED);

            batchTranscriptionResult = await this.makeBatchTranscriptionRetryRequest(
              "", // conversationId
              "", // speechFDUrl
              "", // correlationId
              audioItemInfo.downloadUrl!, // downloadUrl
              locale, // locale
              BatchWorkflowStage.AnalyzeAudio // stage
            );
          } catch (e: any) {
            if (!isNullOrUndefined(e)) {
              switch (e.code) {
                case BatchTranscriptionClientErrorCode.FILE_DECODE_ERROR:
                  throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.FileDecodeError, e.message);
                case BatchTranscriptionClientErrorCode.FILE_NOT_EXIST:
                  throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.FileNotExist, e.message);
                case BatchTranscriptionClientErrorCode.DELETED:
                  throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.DeletedTranscript, e.message);
                default:
                  throw e;
              }
            }
          }

          this.updateFileUploadState(FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_SUCCESS);

          if (!batchTranscriptionResult || !batchTranscriptionResult.conversationId) {
            throw new Error("ConversationId in batch transcription result is null");
          }

          return batchTranscriptionResult.conversationId!;
        },

        // Get batch result
        async (conversationId: string): Promise<ITranscription> => {
          this.updateFileUploadState(FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED);

          const delay = GetDelayTimeInMilliSecondForBatchTranscriptionTask(this.file.size);
          this.StartFileUploadTaskProgressPercentageTimer(
            this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[0],
            this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[1],
            delay
          );

          const logServiceEventGetResult = new LogServiceEvent(LogEventNames.ServiceBatchTranscriptionGetResult);
          logServiceEventGetResult.Start();

          this.fileUploadHistory.AddEventToTranscriptionHistory('Sent batch transcription request');
          const batchTranscriptionResult = await this.makeBatchTranscriptionRetryRequest(
            conversationId, // conversationId
            "", // speechFDUrl
            "", // correlationId
            "", // downloadUrl
            locale, // locale
            BatchWorkflowStage.GetBatchResult // stage
          );

          return await this.handleBatchTranscriptionResult(batchTranscriptionResult, locale);
        }
      ]);
    } else if (currentTranscriberType === TranscriberType.Fast) {
      return new TaskList<BatchTranscriptionUploadTaskListTypes>([
        ...baseTaskList,

        // Initialize batch transcription client
        async (oneDriveItemInfo: IOneDriveItemInfo): Promise<IOneDriveItemInfo> => {
          this.TrySetLoadingPercentDone(
            this.fileUploadWithUrlPercentagesRanges.batchTranscriptionClientInitialized[0]
          );

          await this.EnsureProperConnectivity();
          await ProvisionAuthenticationToken(this.authProvider);
          this.alRuntimeManager = await EnsureAugloopRuntimeManager();
          await this.EnsureBatchTranscriptionClientInitialized();
          return oneDriveItemInfo;
        },

        // Get batch result directly
        async (audioItemInfo: IOneDriveItemInfo): Promise<ITranscription> => {
          if (!audioItemInfo?.downloadUrl) {
            throw new Error("Didn't get downloadUrl for audio file from Graph API");
          }

          this.updateFileUploadState(FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED);

          try {
            const delay = GetDelayTimeInMilliSecondForBatchTranscriptionTask(this.file.size);
            this.StartFileUploadTaskProgressPercentageTimer(
              this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[0],
              this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[1],
              delay
            );
          } catch (e) {
            LogEvents.FileUpload.AddData([
              { key: FileUploadKeys.FileUploadForegroundTaskError, value: `Error in StartFileUploadTaskProgressPercentageTimer: ${ErrorStringFromException(e)}` },
            ]);
          }
          const logServiceEventGetResult = new LogServiceEvent(LogEventNames.ServiceBatchTranscriptionGetResult);
          logServiceEventGetResult.Start();

          this.fileUploadHistory.AddEventToTranscriptionHistory('Sent batch transcription request');
          const batchTranscriptionResult = await this.makeBatchTranscriptionRetryRequest(
            "", // conversationId
            "", // speechFDUrl
            "", // correlationId
            audioItemInfo.downloadUrl, // downloadUrl
            locale, // locale
            BatchWorkflowStage.GetBatchResult // stage
          );

          return await this.handleBatchTranscriptionResult(batchTranscriptionResult, locale);
        }
      ]);
    }

    // Default task list for Ovfd
    return new TaskList<BatchTranscriptionUploadTaskListTypes>([
      ...baseTaskList,

      // Pass download url to FrontDoor
      async (audioItemInfo: IOneDriveItemInfo): Promise<FrontDoorUploadResult> => {
        if (!audioItemInfo?.downloadUrl) {
          throw new Error("Didn't get downloadUrl for audio file from Graph API");
        }

        const sessionId = uuidv4();
        const correlationId = uuidv4();

        LogEvents.FileUpload.AddData([
          { key: FileUploadKeys.FrontDoorSessionId, value: sessionId },
          { key: FileUploadKeys.CorrelationId, value: correlationId }
        ]);

        this.frontDoorUpload = new FrontDoorFileUpload(this.fileUploadHistory);
        try {
          this.updateFileUploadState(FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_INITIATED);
          this.fileUploadHistory.AddEventToTranscriptionHistory(
            `Transcription FrontDoor upload session ID: ${sessionId} and correlation ID: ${correlationId}`
          );

          LogEvents.FileUpload.AddData([
            { key: FileUploadKeys.TranscriptionLocale, value: locale }
          ]);

          const result = await this.frontDoorUpload.AnalyzeAudio(
            sessionId,
            audioItemInfo.downloadUrl,
            GetFileContentTypeFileUpload(this.file),
            (percent: number) => {
              this.TrySetLoadingPercentDone(
                RescalePercent(
                  percent,
                  this.fileUploadWithUrlPercentagesRanges.analyzeAudioAtFrontDoor[0],
                  this.fileUploadWithUrlPercentagesRanges.analyzeAudioAtFrontDoor[1]
                )
              );
            },
            async () => {},
            locale,
            correlationId
          );

          this.updateFileUploadState(FileUploadState.ANALYSE_AUDIO_AT_FRONTDOOR_SUCCESS);
          return result;
        } catch (e) {
          if (e instanceof FrontDoorFileUploadError) {
            throw PublicErrorFromFrontDoorUploadError(e);
          }
          throw e;
        }
      },

      // Initialize batch transcription client
      async (frontDoorUploadResult: FrontDoorUploadResult): Promise<FrontDoorUploadResult> => {
        LogEvents.ServiceLiveSpeechToText.AddResponse({
          isSuccessful: true,
          message: 'Successfully send file upload URL to FD',
          isFinalResponse: true
        });

        this.TrySetLoadingPercentDone(
          this.fileUploadWithUrlPercentagesRanges.batchTranscriptionClientInitialized[0]
        );

        await this.EnsureProperConnectivity();
        this.alRuntimeManager = await EnsureAugloopRuntimeManager();
        await this.EnsureBatchTranscriptionClientInitialized();
        return frontDoorUploadResult;
      },

      // Get batch result
      async (frontDoorUploadResult: FrontDoorUploadResult): Promise<ITranscription> => {
        this.updateFileUploadState(FileUploadState.FETCH_BATCH_TRANSCRIPTION_RESULT_INITIATED);

        const delay = GetDelayTimeInMilliSecondForBatchTranscriptionTask(this.file.size);
        this.StartFileUploadTaskProgressPercentageTimer(
          this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[0],
          this.fileUploadWithUrlPercentagesRanges.getBatchTranscriptionResult[1],
          delay
        );

        const batchTranscriptionResult = await this.makeBatchTranscriptionRetryRequest(
          frontDoorUploadResult.conversationId,
          frontDoorUploadResult.speechFDUrl,
          frontDoorUploadResult.correlationId || "",
          "", // downloadUrl
          locale, // sourceLanguage
          BatchWorkflowStage.GetBatchResult, // stage
        );

        return await this.handleBatchTranscriptionResult(batchTranscriptionResult, locale);
      }
    ]);
  }

  private waitForFileUploadToResume() {
    return new Promise<void>((resolve, _) => {
      const onFileUploadResumed = () => {
        this.unRegisterFileuploadResumeCallback(onFileUploadResumed);
        resolve();
      };

      this.registerFileuploadResumeCallback(onFileUploadResumed);
    })
  }

  private registerFileuploadResumeCallback(callback: Function) {
    this.fileUploadResumeCallbackList.add(callback);
  }

  private unRegisterFileuploadResumeCallback(callback: Function): boolean {
    return this.fileUploadResumeCallbackList.delete(callback);
  }

  private NotifyFileUploadResumeEvent() {
    this.fileUploadResumeCallbackList.forEach(callback => {
      callback();
    });
  }

  private async EnsureProperConnectivity() {
    this.fileUploadHistory.AddEventToTranscriptionHistory("EnsureProperConnectivity...");
    if (this.fileUploadState == FileUploadState.PAUSED) {
      await this.waitForFileUploadToResume();
    }
    else if (!IsConnectedToNetwork() || !await GetNetworkConnectionMonitorInstance().isPingConnected()) {
      this.updateFileUploadState(FileUploadState.PAUSED);
      await this.waitForFileUploadToResume();
    }
    this.fileUploadHistory.AddEventToTranscriptionHistory("EnsureProperConnectivity Resolved");
    Promise.resolve();
  }

  private shouldAddMinutesToHost(transcriptionData: TranscriptionData): boolean {

    // Only add upload minutes if this transcript has more than zero segment or if it is triggered from recovering, do not add the minutes
    return !(transcriptionData.GetTranscription().transcriptSegments.length == 0 || this.fileUploadEntryPoint == FileUploadEntryPoints.RECOVERING)
  }

  // Executes the tasks required for the file upload scenario.
  private GetFileUploadWithUrlTaskList(): TaskList<any> {
    return new TaskList<void | ITranscription | IStoredTranscription | StoredTranscriptionAndSourceFileProvider | ITranscriptionSourceFileProvider>([
      // Tasks to transcribe file --->
      //  1. Do the upload
      async (): Promise<ITranscription> => {
        LogEvents.FileUpload.AddData([{ key: FileUploadKeys.IsNewFileUploadDesign, value: true /* file upload new design*/ }]);
        const fileExtension: string | undefined = this.file.name.split('.').pop();
        if (fileExtension) {
          LogEvents.FileUpload.AddData([{ key: FileUploadKeys.AudioFileExtension, value: fileExtension }]);
        }

        LogEvents.FileUpload.AddData([{ key: FileUploadKeys.AudioFileMIMEType, value: GetFileContentTypeFileUpload(this.file) }]);
        LogEvents.FileUpload.AddData([{ key: FileUploadKeys.AudioFileSizeBytes, value: this.file.size }]);
        LogEvents.FileUpload.BeginDurationMeasure(DurationMeasureType.Normal, FileUploadKeys.TranscriptionProcessDuration);

        let transcription = null;
        CheckNetworkConnection();
        this.batchTranscriptionUploadTaskList = this.GetBatchTranscriptionUploadWithUrlTaskList();
        const fastUploadTaskListResult = await this.batchTranscriptionUploadTaskList.ExecuteTaskListSequentially();
        transcription = <ITranscription>fastUploadTaskListResult.result;

        LogEvents.FileUpload.EndDurationMeasure(FileUploadKeys.TranscriptionProcessDuration);
        LogEvents.ServiceLiveSpeechToText.AddResponse({ isSuccessful: true, message: '', isFinalResponse: true });
        return transcription;
      },

      // <--- Transcribing file ends

      // Create transcription manager.
      async (transcription: ITranscription): Promise<IStoredTranscription> => {
        if (this.oneDriveUploadResult == null) {
          throw new Error("UploadFile returned a null uploadResult");
        }
        return {
          storageType: GetSupportedTranscriptionStorageType(),
          descriptor: {
            transcription,
            audioOneDriveItem: this.oneDriveUploadResult.oneDriveItem,
          }
        };
      },

      // Write stored transcription to document storage.
      async (storedTranscription: IStoredTranscription): Promise<StoredTranscriptionAndSourceFileProvider> => {
        // Show 96% progress indicator
        await waitIfSystemInSleepState();
        this.updateFileUploadState(FileUploadState.WRITE_TRANSCRIPTION_TO_STORAGE);
        LogEvents.FileUpload.BeginDurationMeasure(DurationMeasureType.Normal, FileUploadKeys.WriteContentToClientStorageDuration);
        let writeRequestRetryAttempt = 0;
        await PromiseWithRetry<void>(async () => {
          if (writeRequestRetryAttempt++ > 0) {
            await waitIfSystemInSleepState();
            this.fileUploadHistory.AddEventToTranscriptionHistory("RETRYING WRITE_TRANSCRIPTION_TO_STORAGE");
          }
          return TranscriptionManagerFactory.GetInstance().WriteTranscriptionToStorage(storedTranscription);
        }, MAX_RETRY_ATTEMPTS_FOR_WRITE_REQUEST, MAX_RETRY_DELAY_FOR_WRITE_REQUEST_IN_MSEC);
        LogEvents.FileUpload.EndDurationMeasure(FileUploadKeys.WriteContentToClientStorageDuration);
        if (writeRequestRetryAttempt > 1) {
          LogError(LogEventNames.Warning, "write request succeeded in retry attempt");
        }
        return {
          storedTranscription,
          sourceFileProvider: CreateTranscriptionSourceFileProvider(storedTranscription, this.authProvider),
        }
      },

      // Add upload minutes to the host.
      async (storedTranscriptionAndSourceFileProvider: StoredTranscriptionAndSourceFileProvider): Promise<ITranscriptionSourceFileProvider> => {
        const transcriptionData = new TranscriptionData(storedTranscriptionAndSourceFileProvider.storedTranscription);

        // Show 97% progress indicator
        this.updateFileUploadState(FileUploadState.ADD_MINUTES_TO_HOST);
        if (this.shouldAddMinutesToHost(transcriptionData)) {
          await this.AddUploadMinutesToHost();
        }

        // Show 99% progress indicator
        this.updateFileUploadState(FileUploadState.ADD_MINUTES_TO_HOST_SUCCESS);
        return storedTranscriptionAndSourceFileProvider.sourceFileProvider;
      }
    ]);
  }

  private async makeBatchTranscriptionRetryRequest(
    conversationId: string,
    speechFDUrl: string,
    correlationId: string,
    downloadUrl: string,
    sourceLanguage: string,
    stage: BatchWorkflowStage
  ): Promise<IBatchTranscriptionClientResult> {
    try {
      const logServiceEventGetResult = new LogServiceEvent(LogEventNames.ServiceBatchTranscriptionGetResult);
      logServiceEventGetResult.Start();

      this.makeBatchTranscriptionRetryReqObj = RetryServiceCallUntilSuccessOrTimeout<Promise<IBatchTranscriptionClientResult>>(
        logServiceEventGetResult,
        async () => {
          return new Promise(async (resolve, reject) => {
            // If this is not the first request (i.e. this is a retry), dispose the previous one.
            if (this.batchTranscriptionClientRequestPoller != null) {
              this.DisposeBatchTranscriptionClientRequestPoller();
            }

            await this.EnsureProperConnectivity();

            // this is to make sure on subsequent call, we have proper alRuntimeManager instance.
            this.alRuntimeManager = await EnsureAugloopRuntimeManager();

            try {
              this.fileUploadHistory.AddEventToTranscriptionHistory('Sent batch transcription request');
              resolve(await this.MakeBatchTranscriptionRequest(conversationId, speechFDUrl, correlationId, downloadUrl, sourceLanguage, stage));
            } catch (e: any) {
              // When we dispose a request, this exception will be thrown if the request is pending. Ignore it.
              if (this.isCancelledTask || e !instanceof BatchTranscriptionClientError || e.code != BatchTranscriptionClientErrorCode.REQUEST_DISPOSED || e.code != BatchTranscriptionClientErrorCode.POLLER_DISPOSED) {
                reject(e);
              }
            }
          });
        },
        false /*shouldRetryOnNull*/,
        RetryServiceCaller.BatchTranscriptionRequestInNewFileUploadFlow,
        this.ShouldRetryBatchTranscriptionError,
        () => false,
        GET_BATCH_CONVERSATION_TRANSCRIPTION_TIMEOUT_MILLISECONDS
      );

      const result = await this.makeBatchTranscriptionRetryReqObj.promise;

      if (!result) {
        throw new Error('Received an error during file upload during make batch transcription request');
      }

      return result;
    } catch (e: any) {
      if (!isNullOrUndefined(e)) {
        switch (e.code) {
          case BatchTranscriptionClientErrorCode.FILE_DECODE_ERROR:
            throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.FileDecodeError, e.message);
          case BatchTranscriptionClientErrorCode.FILE_NOT_EXIST:
            throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.FileNotExist, e.message);
          case BatchTranscriptionClientErrorCode.DELETED:
            throw new FileUploadForegroundTaskError(FileUploadForegroundTaskErrors.DeletedTranscript, e.message);
          default:
            throw e;
        }
      }
      throw e;
    }
  }
}